import { useEffect } from "react";
import { BorderButton } from "src/components/buttons/BorderButton";
import ItemCard from "src/components/items/item/ItemCard";
import Container from "src/components/layout/Container";
import { useStore } from "src/stores/Store";
import helmet from "src/utils/helmet";
import { useListBackground } from "src/utils/setListBackground";

export default function Login() {
  const store = useStore();
  useListBackground();

  useEffect(() => {
    helmet.setPageTitle("Logged out");
  }, []);

  return (
    <>
      {store.organization?.logo && (
        <div className="-mb-12 border-b border-borderGray bg-white pb-12">
          <Container>
            <p className="pt-2 text-center">
              <img
                className="max-h-72 rounded"
                src={store.organization.logo.url}
                alt="Organization Logo"
              />
            </p>
          </Container>
        </div>
      )}

      <div className="px-4">
        <div className="mx-auto max-w-lg pb-14 pt-4">
          <ItemCard>
            <h3 className="mb-2">Logged out</h3>

            <p>Your session has expired. Please sign in again.</p>

            <BorderButton type="submit" className="sm:w-full" to={"/login"}>
              Login
            </BorderButton>
          </ItemCard>
        </div>
      </div>
    </>
  );
}
